import React, { useState, useContext, useEffect } from 'react';

import { AuthContext } from './authContext';
import { setCookie, getCookie, deleteCookie } from '../../utils/index';

import { api } from '../../utils/api';
import { COOKIE_EXPIRES_TIME } from '../../utils/constant';

import history from '../../history';

export const AuthState = ({ children }) => {
	const [currentUser, setCurrentUser] = useState(null);
	const [isUserLoading, setUserLoading] = useState(false);

	const handleSignOut = () => {
		setCurrentUser(null);
		deleteCookie('userInfo');
	};

	const handleSignUp = async userInfo => {
		const {
			channelName,
			subtitle,
			accountEmail,
			link,
			description,
			fullName,
			userName,
			dateOfBirth,
			userEmail,
			password
		} = userInfo;

		const userAccount = {
			'title': channelName,
			subtitle,
			'email': accountEmail,
			link,
			description
		};

		try {
			setUserLoading(true);
			const accountRes = await api.post('/account', userAccount);
			const accountId = accountRes.data.account_id;

			const newUser = {
				'fullname': fullName,
				'username': userName,
				'email': userEmail,
				'date_of_birth': dateOfBirth,
				'password': password,
				'confirm_password': password,
				'account_id': accountId
			};

			const userRes = await api.post('/user', newUser);

			setCurrentUser(userRes.data);
			setUserLoading(false);
			setCookie({
				username: userName,
				password: password
			});
			history.push('/my-streams');
		} catch (e) {
			setUserLoading(false);
			throw new Error(e.message);
		}

	};

	const handleLogin = async (userInfo, isCookieAuth, showAlert, hideAlert) => {
		try {
			setUserLoading(true);

			const userRes = await api.post('/login', userInfo);

			if (userRes.data.success == 1) {

				if (isCookieAuth) {
					setCurrentUser(userRes.data);
					setUserLoading(false);
				} else {
					setCookie('userInfo', JSON.stringify(userInfo), {expires: COOKIE_EXPIRES_TIME});
					showAlert('Successfully logged in', 'success');
					setTimeout(() => {
						setUserLoading(false);
						setCurrentUser(userRes.data);
						history.push('/my-streams');
					}, 1000);
				}

			}

			if (userRes.data.success == 0) {
				showAlert(userRes.data.message, 'danger');
				setUserLoading(false);

				return userRes;
			}

		} catch (e) {
			setUserLoading(false);
			throw new Error(e.message);
		}

	};

	const handleRestorePassword = async (email, showAlert, hideAlert) => {
		try {
			setUserLoading(true);

			const userRes = await api.post('/forgotpw', {email: email});

			if (userRes.data.success == 1) {
				setUserLoading(false);
				showAlert(`Your new password: ${userRes.data.password}`, 'success');

				return true;
			}

			if (userRes.data.success == 0) {
				showAlert(userRes.data.message, 'danger');
				setUserLoading(false);

				return false;
			}

		} catch (e) {
			setUserLoading(false);
			throw new Error(e.message);
		}
	};

	useEffect(() => {
		const user = getCookie('userInfo');

		if (user) {
			handleLogin(user, true);
		}

	}, []);

	return (
		<AuthContext.Provider
			value={{
				currentUser,
				handleSignUp,
				handleSignOut,
				handleLogin,
				handleRestorePassword,
				isUserLoading
			}}
		>
			{children}
		</AuthContext.Provider>
	);

};